module.exports = __webpack_public_path__ + "fonts/Quicksand-600-vietnamese10.acc5504.woff2";